// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import routers from './routers'
import axios from 'axios'
import {post,fetch,patch,put} from './api'
import global from './components/global'
import $ from 'jquery'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import 'vue-layer-mobile/need/layer.css'
import layer from 'vue-layer-mobile'
import 'swiper/dist/css/swiper.css'
import './css/animate.css'
Vue.use(layer)
Vue.use(VueCookies);
Vue.use(Vuex)
Vue.use(global)
Vue.prototype.global = global
Vue.prototype.$post=post
Vue.prototype.$fetch=fetch
Vue.prototype.$patch=patch
Vue.prototype.$put=put
Vue.config.productionTip = false
Vue.use(VueRouter)
const router = new VueRouter({
  routes: routers
})
const store = new Vuex.Store({
  // 定义状态
  state: {
    recruitScrollY:0
  },

})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'

});
$.ajaxSetup({
  crossDomain: true,
  xhrFields: {
    withCredentials: true
  },
  headers: {
    "X-Requested-With": "XMLHttpRequest" ,
    "Content-Type": "application/x-www-form-urlencoded"
  }
});
export default{

}



// WEBPACK FOOTER //
// ./src/main.js